import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height }: SvgIconProps) => (
  <img src={`/img/svg/${src}`} alt={src} width={width} height={height} />
);


export const LogoIcon = ({ src, width, isFooter }: {
  src: string
  width: string
  isFooter?: boolean
}) => (
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>

    {isFooter &&

      <div style={{ fontSize: '1.8rem' }} >
        &copy;
      </div>
    }

    <img src={`/img/icons/${src}`} alt={src} width={40} />
    <div style={{ fontFamily: "'Cocogoose Reg' , sans-serif", textTransform: 'uppercase', fontSize: '1.5rem' }} >
      Krishanovate {isFooter && " LLP"}
    </div>
  </div>
);